import { HttpClient } from '@wix/http-client';
import { WIX_META_SITE_ID_HEADER } from '../config/consts';
import { useAppStore } from '../stores/appStore';

const baseURL = window.location.origin + window.__BASEURL__;

function getHeadersWithMetaSiteId(): Record<string, string> {
  const metaSiteId = useAppStore.getState().metaSiteId;
  return metaSiteId ? { [WIX_META_SITE_ID_HEADER]: metaSiteId } : {};
}

const client = new HttpClient({ baseURL, createHeaders: getHeadersWithMetaSiteId });

const ambassador = new HttpClient({ createHeaders: getHeadersWithMetaSiteId });

export const httpUtils = {
  client,
  ambassador,
  getHeadersWithMetaSiteId,
};
